module.exports = __webpack_public_path__ + "img/aocs1.31ee5f1a.png";